import React, { FC } from "react";
import { FiLogOut } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import { NAV_LINKS } from "../../lib/constants/links";

interface HeaderProps {
  open: boolean;
}

const Header: FC<HeaderProps> = ({ open }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    navigate("/auth/login");
  };

  return (
    <header className="bg-black text-white flex justify-between items-center px-10 py-2 w-full fixed top-0 left-0 z-10 h-20">
      <nav className="hidden lg:flex space-x-12 text-center">
        {NAV_LINKS.map((link, index) => (
          <Link
            key={index}
            to={link.path}
            className="text-gray-300 ml-12 hover:text-gray-500 uppercase"
          >
            {link.name}
          </Link>
        ))}
      </nav>

      {/* <div className="flex items-center space-x-6">
        <FiLogOut
          size={24}
          onClick={handleLogout}
          className="cursor-pointer hover:text-gray-400 hidden lg:block"
        />

        <div className="flex flex-col items-center">
          <span className="text-xs mt-1">Home</span>
        </div>
      </div> */}
    </header>
  );
};

export default Header;
